import ReactPlayer from 'react-player'
import '../../../index.css'

const VideoAbout = ({ url }: { url: string }) => {
    return (
        <div className='z-10'>
            <div className='w-[20.5rem] h-[11.553rem] md:w-[28.5rem] md:h-[15.875rem]'>
                <ReactPlayer
                    url={url}
                    className='react-player video-home'
                    width='100%'
                    height='100%'
                    controls={true}
                />
            </div>
        </div>
    )
}

export default VideoAbout